export const getXCurrencies = (assets: IAssets) => assets.filter(value => value.type === 'XCurrency').map(value => value.balance)
